import styled from 'styled-components';

export const AllowanceContainer = styled.div`
  width: 100%;
  max-width: 241px;
  height: fit-content;
  background: var(--detail-bg);
  margin-top: 26px;
  border-radius: 4px;

  @media all and (max-width: 768px) {
    max-width: none;
  }
`;

export const FormContent = styled.form`
  padding: 0 16px 16px;
  border-bottom: 1px solid var(--form-border);

  h2 {
    font-size: 14px;
    font-weight: 700;
    color: var(--luft-secondary-darker);
    font-family: "PT Sans", sans-serif;
  }

  button {
    width: 100%;
    height: 32px;
    background-color: var(--luft-primary);
    color: var(--white);
    font-size: 14px;
    font-family: "PT Sans", sans-serif;
    font-weight: normal;
    border: none;
    outline: none;
    cursor: pointer;
    text-transform: uppercase;
    margin-top: 18px;
    transition: filter 0.2s ease;

    &:active {
      filter: brightness(0.8);
    }

    &:disabled {
      background-color: var(--gray-secondary-light);
      color: var(--lighting-opacity-gray);
      cursor: not-allowed;
    }
  }
`;

export const ControlLabel = styled.div`
  width: 100%;
  max-width: 209px;
  height: 32px;
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 0;
  padding-left: 10px;
  color: var(--luft-primary);

  input {
    width: 12px;
    height: 12px;
    color: var(--luft-secondary-darker);
  }

  span {
    font-size: 12px;
    font-family: "'PT Sans', sans-serif", sans-serif;
    font-weight: normal;
    padding-left: 10px;
  }
`;

export const ListContainer = styled.div`
  padding: 0 12px 16px;

  h2 {
    font-size: 14px;
    font-weight: 700;
    color: var(--luft-secondary-darker);
    font-family: "PT Sans", sans-serif;
  }
`;

export const ListContent = styled.div`
  overflow-y: scroll;
  height: 142px;
  padding-right: 12px;
  box-shadow: rgb(87 87 87 / 3%) 0px -30px 15px 0px inset;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: none;
  }

  &::-webkit-scrollbar-thumb {
    background-color: var(--mid-gray-detail);
    border-radius: 8px;

    &:hover {
      filter: brightness(0.9);
    }
  }
`;

export const ListItem = styled.div`
  width: 100%;
  height: 34px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 20px;
`;

export const UserInfo = styled.span`
  font-size: 12px;
  font-style: italic;
  font-family: "PT Sans", sans-serif;
  color: var(--light-opacity-gray);
`;

export const DateAndTimeInfo = styled.div`
  span {
    font-size: 14px;
    color: var(--dark-blue);
    font-family: "PT Sans", sans-serif;
  }
`;

export const EmpytContent = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  border: 1px dashed var(--secondary-gray);

  height: 142px;
  border-radius: 4px;

  span {
    color: var(--lighting-opacity-gray);
  }
`;
